<footer>
  <div class="footer__logo">
    <a [routerLink]="['/']">
      <img src="/assets/logos/logo_footer.webp" alt="Real Betis">
    </a>
  </div>

  <div class="footer__interest" *ngIf="!showHeaderForInvitation">
    <app-footer-newsletter class="interest-container"></app-footer-newsletter>
    <app-footer-menu class="interest-container"></app-footer-menu>
  </div>
  <div class="footer__legal">
    <div class="legal-copy"><span>© REAL BETIS BALOMPIE.</span> {{"estaPaginaWebEsLaUnicaOficialDelClubRealBetisBalompie" | transloco}}
    </div>
    <div class="legal-links">
      <a href="https://www.realbetisbalompie.es/legal">{{"avisosLegales" | transloco}}</a>
      <a href="https://www.realbetisbalompie.es/privacidad">{{"politicaDePrivacidad" | transloco}}</a>
      <a href="https://www.realbetisbalompie.es/cookies">{{"cookies" | transloco}}</a>
      <a href="https://www.realbetisbalompie.es/accesibilidad">{{"accesibilidad" | transloco}}</a>
    </div>
  </div>
</footer>
